@if (category) {
  <app-product-category-atom
    [id]="category[categoryKeys.Id]"
    [heading]="category[categoryKeys.Name]"
    [description]="category[categoryKeys.Description] ?? ''"
    [level]="level ?? 0"
    [categoryNameColor]="categoryNameColor"
    [categoryDescriptionColor]="categoryDescriptionColor"
  ></app-product-category-atom>
}

<app-product-push-list-atom
  displayContext="shop_page"
  [products]="products"
  [isOrderingAllowed]="isOrderingAllowed"
  [productNameColor]="productNameColor"
  [productDescriptionColor]="productDescriptionColor"
  [productPriceColor]="productPriceColor"
  [productImagePlaceholderColor]="productImagePlaceholderColor"
  [productBorderColor]="productBorderColor"
  [productBackgroundColor]="productBackgroundColor"
  [productHoverColors]="productHoverColors"
  [tagColors]="tagColors"
  (requestGoToProduct)="requestGoToProduct($event)"
></app-product-push-list-atom>
